import type { Rarity } from "@/domain/gems-game/domain/lib/Earning";
import type { PredictedStatsResponse } from "@/domain/gems-game/domain/lib/Sweepstake";
import { onDarkBase } from "@biom3/design-tokens";
import {
  Box,
  Popover,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { ProgressBarDropdownContent } from "./ProgressBar/ProgressBarDropdownContent";

interface Props {
  userStats?: PredictedStatsResponse;
  currentRarity: Rarity;
  hideTrigger?: boolean;
  anchorPosition?: { top: number; left: number } | null;
  open?: boolean;
  onCloseExtern?: () => void;
}

export const WeeklyRewardsInfoDropdown = ({
  userStats,
  currentRarity,
  anchorPosition: controlledAnchorPosition,
  open: controlledOpen,
  onCloseExtern,
}: Props) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const anchorPosition = controlledAnchorPosition;
  const open = Boolean(controlledOpen);

  const handleClose = () => {
    onCloseExtern?.();
  };

  return (
    <Popover
      anchorReference="anchorPosition"
      anchorPosition={anchorPosition || undefined}
      open={open}
      onClose={handleClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
      slotProps={{
        backdrop: {
          sx: {
            backgroundColor: "rgba(0, 0, 0, 0.5)",
          },
        },
        paper: {
          elevation: 8,
          sx: {
            backgroundColor: onDarkBase.color.neutral[900],
            border: `1px solid ${onDarkBase.color.neutral[600]}`,
            maxWidth: isMobile ? "calc(100% - 48px)" : "720px",
            maxHeight: isMobile ? "70vh" : "80vh",
            overflow: "auto",
          },
        },
      }}
    >
      <Box
        sx={{
          p: onDarkBase.spacing.x6,
        }}
      >
        {userStats ? (
          <ProgressBarDropdownContent
            userStats={userStats}
            rarity={currentRarity}
            onClose={handleClose}
          />
        ) : (
          <Typography
            variant="body2"
            sx={{
              color: onDarkBase.color.text.body.secondary,
              fontStyle: "italic",
            }}
          >
            Loading quest information...
          </Typography>
        )}
      </Box>
    </Popover>
  );
};
